import axios from 'axios';

export const questionsService = {
  getHistory: () => axios.get('/userquestionanswer', { token: true }),
  getQuestions: () => axios.get('/question', { token: true }),
  submitQuestionAnswers: (body) => axios.post('/request', body, { token: true }),
};
